import {Dispatch, SetStateAction} from 'react'

export type ID = undefined | null | number

export type PaginationState = {
  currentPage: number
  totalItems:number
  totalPages:number
  pageSize: number
  links: Array<{label: string; active: boolean; url: string | null; page: number | null}>}

  
export type SortState = {
  sort?: string
  order?: 'asc' | 'desc'
}

export type FilterState = any

export type SearchState = {
  search?: string
}
export type LanguageState = {
  language?: string
}

export type Response<T> = {
  pagination: PaginationState
  data?: T
  message?:string
  code?:number
  payload?: {
    message?: string,
    code?:number
    errors?: {
      [key: string]: Array<string>
    }
    pagination?: PaginationState
  }
 
}

export type QueryState = PaginationState & SortState & FilterState & SearchState & LanguageState

export type QueryRequestContextProps = {
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}
const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig';

const ls = localStorage.getItem(I18N_CONFIG_KEY) || '{"selectedLang":"en"}'; 
const config = JSON.parse(ls); 
const selectedLang = config.selectedLang; 

export const initialQueryState: QueryState = {
  page: 0,
  size: 10,
  language:selectedLang || 'en'
}

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {},
}

export type QueryResponseContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  rolesResponse?: Response<Array<T>> | undefined
  refetchRoles: () => void
  refetchData: () => void

  isLoading: boolean
  query: any
}

export const initialQueryResponse = { refetchRoles: () => {},refetchData: () => {}, isLoading: false, query: '' }

export type ListViewContextProps = {
  selected: Array<ID>
  onSelect: (selectedId: ID) => void
  onSelectAll: () => void
  clearSelected: () => void
  // NULL => (CREATION MODE) | MODAL IS OPENED
  // NUMBER => (EDIT MODE) | MODAL IS OPENED
  // UNDEFINED => MODAL IS CLOSED
  itemIdForUpdate?: ID
  setItemIdForUpdate: Dispatch<SetStateAction<ID>>
  isAllSelected: boolean
  disabled: boolean
}

export const initialListView: ListViewContextProps = {
  selected: [],
  onSelect: () => {},
  onSelectAll: () => {},
  clearSelected: () => {},
  setItemIdForUpdate: () => {},
  isAllSelected: false,
  disabled: false,
}
